require('./paymentChoreStep.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { AmountInput } = require('commonsComponents/amountInput');
const { LoadingDots } = require('commonsComponents/loadingDots');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @actions
const openYoungCardPaymentChore = require('actions/openYoungCardPaymentChore');

// @ utilities
const currencyHelper = require('utilities/currencyHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getCardAvailableBalance } = require('utilities/cardsHelper');

//@constants
const { EURO_TEXT, CHORE_MAX_AMOUNT, CHORE_MIN_AMOUNT } = require('constants/index');
const language = getLanguage();

class PaymentChoreStep1 extends React.Component {
    constructor(props){
        super(props);
        this.createList = this.createList.bind(this);
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
        this.setChangedAmount = this.setChangedAmount.bind(this);
        this.getPrepaidBalance = this.getPrepaidBalance.bind(this);
    }

    createList(list) {
        return list.filter(({ bodyText }) => bodyText).map((item, key) => (
            <OKInformativeListItem
                className={"payment-chores-step__list-item"}
                key={key}
                title={item.title}
                bodyText={item.bodyText}
                bodyWordBreak={false}
            />
        ));
    }

    getPrepaidBalance() {
        const { immCard, immCardCharge } = this.props;
        const amount = getCardAvailableBalance(immCard);
        const plainAmountObject = getPlainAmountObject(amount);

        if (immCardCharge.get('isFetching')) {
            return (
                <LoadingDots inline color="dark" size="small" />
            );
        }

        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                className="payment-chores-step__balance"
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
    }

    handleAccountFromChange(accountId) {
        const { setAccount, immAccounts, setAccountAvailableBalance } = this.props;
        setAccount(accountId);
        setAccountAvailableBalance(immAccounts.getIn([accountId,'balances','availableBalance','amount']));
    }

    setChangedAmount(amount) {
        this.props.setAmount(amount, true);
    }

    render() {
        const { immStep, immAccounts, isInactiveAccountsEnabled, accountsIndexes, immCardCharge} = this.props;
        let availableBalanceAmount = immStep.get('cardAvailableBalance');
        const availableBalance = currencyHelper.getFormattedString({
            amount: availableBalanceAmount,
            currency: EURO_TEXT
        });

        const list = [
            {
                title: formatText('openYoungPaymentChores-cardBalance'),
                bodyText: availableBalance
            }
        ];
        const amount = immStep.get('amount');
        const fromAccount = immStep.get('fromAccount');
        const currency = currencyHelper.formatCurrency(EURO_TEXT);
        const choreMinAmount = currencyHelper.getFormattedString({ amount: CHORE_MIN_AMOUNT, currency });
        const choreMaxAmount = currencyHelper.getFormattedString({ amount: CHORE_MAX_AMOUNT, currency });

        const accountDropdownError = !immStep.get('fromAccount') && immStep.get('fromAccountisDirty');
        const accountDropdownErrorMessage = formatText('openYoungPaymentChores-accountError');
        const maxValidAmount = CHORE_MAX_AMOUNT - availableBalanceAmount;
        const amountLesserMinimum = immStep.get('amount') < CHORE_MIN_AMOUNT;
        const amountGreaterCardBalance = immStep.get('amount') > maxValidAmount;
        const amountGreaterAccountBalance = immStep.get('amount') > immStep.get('accountAvailableBalance') && immStep.get('fromAccount');
        const formattedMaxValidAmount = currencyHelper.getFormattedString({ amount: maxValidAmount, currency })

        let amountErrorMessage = formatText('openYoungPaymentChores-minimumAmountError', [choreMinAmount]);
        if(amountGreaterCardBalance) {
            amountErrorMessage = formatText('openYoungPaymentChores-maximumAmountError', [choreMaxAmount]);
        }else if(amountGreaterAccountBalance) {
            amountErrorMessage = formatText('openYoungPaymentChores-amountGreaterAccountBalanceError');
        }

        const amountError = (amountLesserMinimum || amountGreaterCardBalance || amountGreaterAccountBalance) && immStep.get('amountisDirty');
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        return (
            <article className="payment-chores-step">
                <section>
                    <h2 className="payment-chores-step__heading">{formatText('openYoungPaymentChores-step1Heading')}</h2>
                </section>
                <section className="payment-chores-step__main">
                    <OKInformativeList>
                        <OKInformativeListItem
                            className={"payment-chores-step__list-item"}
                            title={list[0].title}
                            bodyWordBreak={false}
                        >
                            {this.getPrepaidBalance()}
                        </OKInformativeListItem>
                    </OKInformativeList>
                    <div className="payment-chores-step__accounts-dropdown">
                        <DropdownAccounts
                            id="drd_TransferStep1_Origin"
                            label={formatText('openYoungPaymentChores-originAccount')}
                            immAccounts={immAccounts}
                            accountsIndexes={accountsIndexes}
                            currentAccountId={fromAccount}
                            onAccountChange={this.handleAccountFromChange}
                            error={accountDropdownError}
                            errorMsg={accountDropdownErrorMessage}
                            showAvailableBalance={true}
                            enabled={true}
                            showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                            tooltipMsg={tooltipMsgContent}
                        />
                    </div>
                    <div className="payment-chores-step__amount-input">
                        <label>
                            <AmountInput
                                id="inp_TransferStep1_Amount"
                                label={formatText('openYoungPaymentChores-amount')}
                                callback={this.setChangedAmount}
                                min={0}
                                error={amountError}
                                errorMsg={amountErrorMessage}
                                amount={amount}
                                showBlurZero
                                hideFocusZero
                                disablePaste
                                language={language}
                            />
                        </label>
                        <span className="payment-chores-step__currency">
                            {currency}
                        </span>
                        <p className="payment-chores-step__amount-instruction">
                            {!immCardCharge.get('isFetching') && <FormattedText value="openYoungPaymentChores-amountInstruction" injectedStrings={[formattedMaxValidAmount]}/>}
                        </p>
                    </div>
                </section>
            </article>
        );
    }
}

PaymentChoreStep1.propTypes = {
    accountsIndexes: PropTypes.array,
    immAccounts: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.object.isRequired,
    setAccount: PropTypes.func,
    setAccountAvailableBalance: PropTypes.func,
    setAmount: PropTypes.func
}
module.exports.PaymentChoreStep1 = connect(
    null,
    {
        setAccount: openYoungCardPaymentChore.setAccount,
        setAccountAvailableBalance: openYoungCardPaymentChore.setAccountAvailableBalance,
        setAmount: openYoungCardPaymentChore.setAmount
    })(PaymentChoreStep1);
